import 'svelte/internal/disclose-version';

Tasks[$.FILENAME] = 'src/web/concepts/tasks.svelte';

import * as $ from 'svelte/internal/client';
import Booking from "./booking.svelte";

var root = $.add_locations(
	$.from_html(
		`
        <button> </button>
      `,
		1
	),
	Tasks[$.FILENAME],
	[[28, 8]]
);

var root_1 = $.add_locations(
	$.from_html(
		`
    <h1 class="font-display text-3xl md:text-5xl font-semibold tracking-tight">What does your team still do by hand?</h1>
    <div class="flex flex-wrap gap-2">
      <!>
    </div>
    <div class="flex items-end justify-between gap-6 flex-wrap">
      <p class="font-display text-5xl md:text-7xl font-semibold tracking-tight tabular-nums"> <span class="text-2xl md:text-3xl opacity-60"> / week to win back</span></p>
      <button class="btn">Let's automate that</button>
    </div>
  `,
		1
	),
	Tasks[$.FILENAME],
	[[25, 4], [26, 4], [31, 4, [[32, 6, [[32, 104]]], [33, 6]]]]
);

var root_2 = $.add_locations(
	$.from_html(
		`
    <h1 class="font-display text-3xl md:text-5xl font-semibold tracking-tight"> </h1>
    <!>
  `,
		1
	),
	Tasks[$.FILENAME],
	[[36, 4]]
);

var root_3 = $.add_locations(
	$.from_html(
		`

<div class="w-full max-w-4xl flex flex-col gap-8">
  <!>
</div>`,
		1
	),
	Tasks[$.FILENAME],
	[[23, 0]]
);

function Tasks($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, Tasks);

	const catalog = [
		{ name: "Writing quotes", hours: 4 },
		{ name: "Invoicing", hours: 3 },
		{ name: "Scheduling teams", hours: 5 },
		{ name: "Tracking stock", hours: 3 },
		{ name: "Copying data between tools", hours: 6 },
		{ name: "Chasing payments", hours: 2 },
		{ name: "Weekly reporting", hours: 3 },
		{ name: "Client follow-up", hours: 4 },
		{ name: "Timesheets", hours: 2 },
		{ name: "Answering “where's my order?”", hours: 3 }
	];

	let picked = $.tag($.state($.proxy([])), 'picked');
	let booking = $.tag($.state(false), 'booking');
	const hours = $.tag($.derived(() => catalog.filter((t) => $.get(picked).includes(t.name)).reduce((s, t) => s + t.hours, 0)), 'hours');

	const toggle = (name) => $.set(
		picked,
		$.get(picked).includes(name)
			? $.get(picked).filter((p) => $.strict_equals(p, name, false))
			: [...$.get(picked), name],
		true
	);

	var $$exports = { ...$.legacy_api() };

	$.next();

	var fragment = root_3();
	var div = $.sibling($.first_child(fragment));
	var node = $.sibling($.child(div));

	{
		var consequent = ($$anchor) => {
			var fragment_1 = root_1();
			var div_1 = $.sibling($.first_child(fragment_1), 3);
			var node_1 = $.sibling($.child(div_1));

			$.add_svelte_meta(
				() => $.each(node_1, 17, () => catalog, $.index, ($$anchor, t) => {
					$.next();

					var fragment_2 = root();
					var button = $.sibling($.first_child(fragment_2));
					var text = $.only_child(button, true);

					$.next();

					$.template_effect(
						($0) => {
							$.set_class(button, 1, $0);
							$.set_text(text, $.get(t).name);
						},
						[
							() => $.clsx([
								"px-4 py-2 border-2 border-ink font-semibold text-lg transition-colors",
								$.get(picked).includes($.get(t).name) ? "bg-ink text-accent" : "hover:bg-ink/10"
							])
						]
					);

					$.delegated('click', button, function click() {
						return toggle($.get(t).name);
					});

					$.append($$anchor, fragment_2);
				}),
				'each',
				Tasks,
				27,
				6
			);

			$.next();
			$.reset(div_1);

			var div_2 = $.sibling(div_1, 2);
			var p_1 = $.sibling($.child(div_2));
			var text_1 = $.child(p_1);

			$.next();
			$.reset(p_1);

			var button_1 = $.sibling(p_1, 2);

			$.next();
			$.reset(div_2);
			$.next();

			$.template_effect(() => {
				$.set_text(text_1, `≈ ${$.get(hours) ?? ''} h`);
				button_1.disabled = !$.get(picked).length;
			});

			$.delegated('click', button_1, function click_1() {
				return $.set(booking, true);
			});

			$.append($$anchor, fragment_1);
		};

		var alternate = ($$anchor) => {
			var fragment_3 = root_2();
			var h1 = $.sibling($.first_child(fragment_3));
			var text_2 = $.only_child(h1);
			var node_2 = $.sibling(h1, 2);

			{
				let $0 = $.derived(() => $.get(picked).join(", "));

				$.add_svelte_meta(
					() => Booking(node_2, {
						get summary() {
							return $.get($0);
						}
					}),
					'component',
					Tasks,
					37,
					4,
					{ componentTag: 'Booking' }
				);
			}

			$.next();
			$.template_effect(() => $.set_text(text_2, `${$.get(picked).length ?? ''} tasks, ≈ ${$.get(hours) ?? ''} hours a week. Let's talk about them.`));
			$.append($$anchor, fragment_3);
		};

		$.add_svelte_meta(
			() => $.if(node, ($$render) => {
				if (!$.get(booking)) $$render(consequent); else $$render(alternate, -1);
			}),
			'if',
			Tasks,
			24,
			2
		);
	}

	$.next();
	$.reset(div);
	$.append($$anchor, fragment);

	return $.pop($$exports);
}

if (import.meta.hot) {
	Tasks = $.hmr(Tasks);

	import.meta.hot.accept((module) => {
		Tasks[$.HMR].update(module.default);
	});
}

export default Tasks;

$.delegate(['click']);